import { Link } from 'react-router-dom';
import './Page.css';

export default function About() {
  return (
    <div className='page'>
      <h2 className='subheadline-black exception-2'>O wydarzeniu</h2>
      <div className='page-text'>
        <p>
          <b>Otwarte Pracownie na Mazurach</b> to zaproszenie do zobaczenia
          mazurskiej krainy z innej strony: bądź blisko przyrody, odwiedzaj
          twórców, rozmawiaj, poznawaj, ucz się, zyskaj nową perspektywę.
        </p>

        <figure>
          <img
            src={`${process.env.PUBLIC_URL}/img/photo/edycja-2024/otwarte-pracownie-edycja-2024-1.jpg`}
            alt='edycja 2024 - 1'
            className='photo'
          />
          <figcaption>autorka zdjęcia: Monika Sieklucka</figcaption>
        </figure>

        <p>
          Wydajemy mapę Mazur, dzięki której odkryjesz prywatne pracownie,
          domowe galerie, warsztaty twórcze: ceramiczne, malarskie,
          rzeźbiarskie, graficzne, tkackie i wiele innych. Spotkasz
          rękodzielników i artystów, którzy realizują swoje pasje, chętnie
          dzielą się wiedzą i doświadczeniem, żyją i pracują w pięknych
          miejscach. W dniach 11–12 lipca 2026 drzwi do tych miejsc otwierają
          się szeroko. Ale to nie jedyna okazja, wielu artystów chętnie przyjmie
          Cię także poza oficjalnym terminem. Wystarczy napisać, zadzwonić,
          zapytać.
        </p>

        <div className='photo-container-2-horizontal'>
          <figure>
            <img
              src={`${process.env.PUBLIC_URL}/img/photo/edycja-2024/otwarte-pracownie-edycja-2024-2.jpg`}
              alt='edycja 2024 - 2'
              className='photo-vertical'
            />

            <figcaption>autorka zdjęcia: Monika Sieklucka</figcaption>
          </figure>

          <figure>
            <img
              src={`${process.env.PUBLIC_URL}/img/photo/edycja-2024/otwarte-pracownie-edycja-2024-3.jpg`}
              alt='edycja 2024 - 3'
              className='photo-vertical'
            />

            <figcaption>autorka zdjęcia: Monika Sieklucka</figcaption>
          </figure>
        </div>
        <p>
          Wartościami, które stoją u podstaw pomysłu na Otwarte Pracownie są:
        </p>
        <h3 className='subheadline-upper'>spotkania międzyludzkie offline </h3>
        <p>
          Rzeczywiste spotkania, zwykła rozmowa, oglądanie prac na żywo,
          przebywanie, edukacja;
        </p>

        <div className='photo-container-2-horizontal'>
          <figure>
            <img
              src={`${process.env.PUBLIC_URL}/img/photo/edycja-2024/otwarte-pracownie-edycja-2024-4.jpg`}
              alt='edycja 2024 - 4'
              className='photo-vertical'
            />

            <figcaption>autorka zdjęcia: Monika Sieklucka</figcaption>
          </figure>

          <figure>
            <img
              src={`${process.env.PUBLIC_URL}/img/photo/edycja-2024/otwarte-pracownie-edycja-2024-5.jpg`}
              alt='edycja 2024 - 5'
              className='photo-vertical'
            />

            <figcaption>autorka zdjęcia: Monika Sieklucka</figcaption>
          </figure>
        </div>

        <h3 className='subheadline-upper'>kontakt z naturą i ze sztuką</h3>
        <p>
          Uczestnicy Otwartych Pracowni mieszkają na Mazurach. Tutaj funkcjonują
          poprzez działania twórcze. Kontakt człowieka z człowiekiem, z naturą i
          ze sztuką, same w sobie są cenne: rozwijają wrażliwość i empatię,
          poszerzają możliwość widzenia świata, mogą działać terapeutycznie.
        </p>

        <p>
          To co robi natura i to co robi twórczy człowiek, to inicjowanie
          zmiany, mającej na celu rozwój i podtrzymywanie życia. Nadawanie
          znaczenia. W tych staraniach natury i człowieka tkwi piękno.
        <br /><br />
           <h3 className='subheadline-upper no-upper'>
            Mazury są wrażliwe, wędruj z pasją!
          </h3>
        </p>
        <br />
        <button className='btn'>
          <Link to='/edycje'>Sprawdź dotychczasowe edycje wydarzenia</Link>
        </button>
        <br />
        <br />
        <i className='text-photo'>Zdjęcia: Monika Sieklucka</i>
      </div>
    </div>
  );
}
